(()=>{
  'use strict';
  const root=document.documentElement;
  const hero=document.querySelector('.estate-camera');
  const sticky=hero?.querySelector('.estate-camera__sticky');
  const scene=document.getElementById('estate-scene');
  const heading=document.getElementById('estate-heading');
  const portal=document.getElementById('estate-portal-fill');
  const intro=document.getElementById('estate-intro');
  const lyrics=intro?.querySelector('[data-lyrical-reveal]');
  const cta=intro?.querySelector('.estate-intro__story-cta');
  if(!hero||!sticky||!scene||!intro||!lyrics)return;
  root.classList.add('js','is-ready','estate-v196-scroll');
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  const clamp=(x,a=0,b=1)=>Math.min(b,Math.max(a,x));
  const smooth=x=>{x=clamp(x);return x*x*(3-2*x)};
  const lerp=(a,b,t)=>a+(b-a)*t;
  // Image planes alone get depth effects. The heading, nav and camera anchoring
  // are deliberately not touched. Bigger differences than v206 make depth visible
  // even against a short 3x global zoom (world transform stays below Safari-safe bounds).
  // [element id, scroll Y, scroll X, relative zoom, mouse intensity]
  const layers=[
    ['estate-trees-left',-122,-43,.115,15],
    ['estate-trees-right',-92,37,.096,29],
    ['estate-ground',4,0,.000,3],
    ['estate-architecture',4,0,.000,3],
    ['estate-cow-left',96,-32,.170,0],
    ['estate-cow-right',132,27,.205,0]
  ].map(([id,offset,xOffset,depthScale,mouse])=>({el:document.getElementById(id),offset,xOffset,depthScale,mouse}));
  // Pointer easing is a *separate input* to the same requestAnimationFrame loop.
  // No element gets its own listener, interval or animation timer.
  const finePointer=matchMedia('(hover: hover) and (pointer: fine)');
  let pointerTargetX=0,pointerTargetY=0,pointerX=0,pointerY=0,lastFrame=0;
  function setPointer(event){
    if(reduce.matches||!finePointer.matches)return;
    // Track only the hero viewport and gently reset outside it.
    const heroNear=scrollY<=documentTop+normal+pin+innerHeight*.15;
    if(!heroNear){
      if(pointerTargetX||pointerTargetY){pointerTargetX=pointerTargetY=0;schedule();}
      return;
    }
    const bounds=sticky.getBoundingClientRect();
    const inside=bounds.bottom>0&&bounds.top<innerHeight&&event.clientY>=Math.max(0,bounds.top)&&event.clientY<=Math.min(innerHeight,bounds.bottom);
    pointerTargetX=inside?clamp((event.clientX/(innerWidth||1)-.5)*2,-1,1):0;
    pointerTargetY=inside?clamp((event.clientY/(innerHeight||1)-.5)*2,-1,1):0;
    schedule();
  }
  const words=[];
  const copy=lyrics.textContent.trim();
  const fragment=document.createDocumentFragment();
  for(const part of copy.split(/(\s+)/).filter(Boolean)){
    if(/^\s+$/.test(part)){fragment.append(document.createTextNode(part));continue;}
    const word=document.createElement('span');word.className='lyric-word';word.textContent=part;
    fragment.append(word);words.push(word);
  }
  lyrics.replaceChildren(fragment);
  const full='rgb(7, 3, 141)',faded='rgba(7, 3, 141, 0.1)';
  let lastWords=-1,lastPartial=-1,raf=0;
  let W=0,H=0,scale=1,stageTop=0,stageLeft=0,normal=0,pin=0,documentTop=0;
  let headingOffset=245,headingScreenY=0,copyStart=0,copyDistance=1,ctaDistance=1;
  let prevScene='',prevTitle='',prevPlane=Array(layers.length).fill('');
  // Write a style or inherited custom property only when its output changes.
  // Rewriting :root variables on every scroll was invalidating all sections,
  // including when the hero was entirely offscreen.
  const styleCache=new Map();
  function setStyle(element,property,value){
    const key=(element===root?'root':element===intro?'intro':element===sticky?'sticky':'element')+':'+property;
    if(styleCache.get(key)===value)return;
    styleCache.set(key,value);
    if(property.startsWith('--'))element.style.setProperty(property,value);
    else element.style[property]=value;
  }


  function layout(){
    W=document.documentElement.clientWidth||innerWidth;
    H=sticky.clientHeight||innerHeight;
    // Preserve the original Figma placement and existing mobile crop.
    scale=W<=720?W/792:W/1440;
    stageLeft=W/2-720*scale;
    const projectedHeight=1034*scale;
    stageTop=W<=720?H*(294/874):
      (W<1200?Math.max(0,Math.min(H*.19,(H-projectedHeight)*.37)):0);
    // v203: shift ALL original artwork planes and heading upwards together,
    // preserving the existing zoom/perspective and reverse behavior.
    if(W>1100)stageTop-=70*scale;
    normal=Math.max(0,projectedHeight+stageTop-H);
    // A sufficiently long, physically scrollable runway makes both sections
    // reachable even on landscape tablets and with fast trackpad input.
    pin=reduce.matches?Math.max(H*.8,480):Math.max(930,Math.min(1700,H*1.65));
    documentTop=hero.getBoundingClientRect().top+scrollY;
    headingOffset=heading?.offsetTop||245;
    headingScreenY=W<=720?H*(229/874):stageTop+scale*headingOffset-(W<=1100?70*scale:0);
    root.style.setProperty('--estate-scene-height',`${Math.max(H,projectedHeight+stageTop)}px`);
    root.style.setProperty('--estate-runway',`${pin}px`);
    root.style.setProperty('--estate-intro-overlap',`${pin+H}px`);
    // Intro has 650px of hold beyond the camera runway. Complete the
    // lyrical reveal within that stable viewport, not by a second observer.
    copyStart=documentTop+normal+pin*.70;
    ctaDistance=Math.max(100,Math.min(175,H*.18));
    const hold=W<=720?105:125;
    copyDistance=Math.max(280,pin*.30+hold-ctaDistance-80);
    prevScene='';prevTitle='';prevPlane=Array(layers.length).fill('');
    styleCache.clear();
  }
  function renderWords(progress){
    const position=progress*words.length;
    const completed=Math.floor(position);
    const partial=clamp(position-completed);
    // Only the newly completed word and the one still changing receive
    // style writes. This avoids restyling the whole paragraph each frame.
    if(completed===lastWords && Math.abs(partial-lastPartial)<.006)return;
    if(lastWords<0 || Math.abs(completed-lastWords)>3){
      for(let i=0;i<words.length;i++)words[i].style.color=i<completed?full:i===completed&&partial>0?
        `rgba(7, 3, 141, ${(0.1+.9*partial).toFixed(3)})`:faded;
    }else{
      for(let i=Math.max(0,Math.min(lastWords,completed)-1);i<=Math.min(words.length-1,Math.max(lastWords,completed)+1);i++){
        words[i].style.color=i<completed?full:i===completed&&partial>0?
          `rgba(7, 3, 141, ${(0.1+.9*partial).toFixed(3)})`:faded;
      }
    }
    lastWords=completed;lastPartial=partial;
  }
  function render(now){
    raf=0;
    // Frame-rate-independent cursor damping; no scroll smoothing or camera lag.
    const dt=lastFrame?Math.min(.05,Math.max(.001,(now-lastFrame)/1000)):.016;
    lastFrame=now;
    const blend=1-Math.exp(-12*dt);
    pointerX+=(pointerTargetX-pointerX)*blend;
    pointerY+=(pointerTargetY-pointerY)*blend;
    if(Math.abs(pointerX-pointerTargetX)<.001)pointerX=pointerTargetX;
    if(Math.abs(pointerY-pointerTargetY)<.001)pointerY=pointerTargetY;
    const travel=Math.max(0,scrollY-documentTop);
    const arrival=Math.min(normal,travel);
    // Start magnifying while the lower edge of the tall raster scene is still
    // approaching the viewport, rather than waiting for the full lead-in.
    // Expand the zoom interval by the same amount so the end boundary stays
    // identical. This preserves the hero/intro handoff and reverse scrolling.
    const zoomHeadStart=Math.min(normal*.50,H*.13);
    const p=clamp((travel-(normal-zoomHeadStart))/(pin+zoomHeadStart));
    const ease=smooth(p);
    const zoom=reduce.matches?1:1+2*ease;
    const gateScreenY=lerp(stageTop+scale*774-arrival,H*.59,ease);
    const worldX=W/2-720*scale*zoom;
    const worldY=gateScreenY-774*scale*zoom;
    const fade=smooth((p-.60)/.35);
    // Do not hide either section until its successor is being painted.
    const sceneAlpha=1-fade;
    const cameraTransform=`translate3d(${worldX.toFixed(2)}px,${worldY.toFixed(2)}px,0) scale(${(scale*zoom).toFixed(5)})`;
    if(prevScene!==cameraTransform){scene.style.transform=cameraTransform;prevScene=cameraTransform;}
    setStyle(scene,'opacity',sceneAlpha.toFixed(3));
    for(let i=0;i<layers.length;i++){
      const layer=layers[i];if(!layer.el)continue;
      // v209: Match the approved hero screenshot by lifting artwork planes only.
      // The title and masthead continue using the untouched v208 camera transforms.
      // Keep the approved heading's inverse camera transform completely unchanged.
      const desktopArtLift=W>1100?-116/Math.max(scale,.1):0;
      // Fade mouse response during the deep zoom, so the gate stays centered.
      // All translation units are local scene units; the shared camera still
      // zooms to the same portal position. Larger separate rates create depth.
      const cursorWeight=reduce.matches?0:Math.max(0,1-smooth((p-.50)/.45));
      const mouseX=-pointerX*layer.mouse*cursorWeight;
      const mouseY=-pointerY*layer.mouse*.62*cursorWeight;
      const archived202Offsets=[-46,-33,0,0,32,40];
      const movementY=W<=1100?archived202Offsets[i]:layer.offset;
      const shift=desktopArtLift+(reduce.matches?0:movementY*ease)+mouseY;
      const horizontal=(reduce.matches?0:(W<=1100?0:layer.xOffset)*ease)+mouseX;
      const depth=reduce.matches?1:1+(W<=1100?0:layer.depthScale)*ease;
      const tr=`translate3d(${horizontal.toFixed(2)}px,${shift.toFixed(2)}px,0) scale(${depth.toFixed(5)})`;
      if(prevPlane[i]!==tr){layer.el.style.transform=tr;prevPlane[i]=tr;}
    }
    if(heading){
      const titleY=(headingScreenY-worldY)/(scale*zoom)-headingOffset;
      const tr=`translate3d(-50%,${titleY.toFixed(2)}px,0) scale(${(1/zoom).toFixed(5)})`;
      if(prevTitle!==tr){heading.style.transform=tr;prevTitle=tr;}
      heading.style.opacity=(1-smooth((p-.20)/.25)).toFixed(3);
    }
    if(portal)portal.style.opacity=(1-smooth((p-.75)/.18)).toFixed(3);
    setStyle(intro,'--estate-intro-alpha',smooth((p-.58)/.29).toFixed(3));
    setStyle(sticky,'--estate-backdrop-alpha',(1-smooth((p-.62)/.28)).toFixed(3));
    setStyle(root,'--estate-nav-alpha',(1-smooth(p/.20)).toFixed(3));
    const progress=reduce.matches?1:clamp((scrollY-copyStart)/copyDistance);
    const ctaProgress=reduce.matches?1:clamp((scrollY-copyStart-copyDistance)/ctaDistance);
    renderWords(progress);
    // v210: Scroll-linked editorial depth, synchronized with this SAME frame.
    // Different movement distances create subtle independent parallax without
    // changing the existing lyrical word-reveal or CTA activation points.
    // Motion is zero in reduced-motion mode.
    const introDepth=reduce.matches?.5:smooth(clamp((scrollY-copyStart+190)/(copyDistance+ctaDistance+370)));
    const depthFromCenter=introDepth-.5;
    const depthTitle=reduce.matches?0:-30*depthFromCenter;
    const depthCopy=reduce.matches?0:-52*depthFromCenter;
    const depthCta=reduce.matches?0:-68*depthFromCenter;
    const depthLeaves=reduce.matches?0:-20*depthFromCenter;
    setStyle(intro,'--estate-intro-depth-title',depthTitle.toFixed(2)+'px');
    setStyle(intro,'--estate-intro-depth-copy',depthCopy.toFixed(2)+'px');
    setStyle(intro,'--estate-intro-depth-cta',depthCta.toFixed(2)+'px');
    setStyle(intro,'--estate-intro-depth-leaves',depthLeaves.toFixed(2)+'px');
    setStyle(intro,'--estate-intro-copy-progress',progress.toFixed(4));
    setStyle(intro,'--estate-intro-cta-progress',ctaProgress.toFixed(4));
    if(cta)cta.classList.toggle('is-ready',ctaProgress>=.995);
    // Schedule again only while a pointer target is converging. No continuous
    // GPU work after settling, or after the visitor leaves the hero.
    if(Math.abs(pointerX-pointerTargetX)>.001||Math.abs(pointerY-pointerTargetY)>.001)schedule();
  }
  function schedule(){if(!raf)raf=requestAnimationFrame(render)}
  // Called by the one-gesture scroll driver within its own animation frame.
  // Native, keyboard, scrollbar and scripted scrolling keep the existing rAF.
  window.EstateHeroPaintNow=(time)=>{
    if(raf){cancelAnimationFrame(raf);raf=0;}
    render(time||performance.now());
  };
  function refresh(){layout();lastWords=-1;lastPartial=-1;schedule()}
  addEventListener('pointermove',setPointer,{passive:true});
  addEventListener('blur',()=>{pointerTargetX=0;pointerTargetY=0;schedule()});
  finePointer.addEventListener?.('change',()=>{pointerTargetX=0;pointerTargetY=0;schedule()});
  addEventListener('scroll',()=>{if(!window.EstateHeroGestureActive)schedule();},{passive:true});
  addEventListener('resize',refresh,{passive:true});
  addEventListener('pageshow',refresh);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh()});
  reduce.addEventListener?.('change',refresh);
  // Loading fonts can change heading positions but not the scroll length.
  document.fonts?.ready.then(refresh).catch(()=>{});
  refresh();
})();
